export const UPDATE_USER_ID = 'UPDATE_USER_ID';

export const updateUserId = (userId) => ({
  type: UPDATE_USER_ID,
  payload: userId
});
